// extracted by mini-css-extract-plugin
module.exports = {"launchDateDiv":"LaunchDateHeader_launchDateDiv__2NcWn","launchDateHeaderDiv":"LaunchDateHeader_launchDateHeaderDiv__1MNEs","tokenCoinImg":"LaunchDateHeader_tokenCoinImg__XTbWj"};